export const iconFontAwesomeEditingPencil = (
	<i className="fa-solid fa-pencil"></i>
);
